import { UserState } from "../../models/UserState";

const registerVendorSuccess = (state: UserState) => {
    state.isLoading = false;
    state.vendor.isRegistration = true;
    state.isError = null;
}

export default registerVendorSuccess;